import { shiftEditorViewState } from "..";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateStartDateTimeoff", function updateStartDateTimeoff(startDate: Moment) {
    if (startDate) {
        shiftEditorViewState().timeOffStartDate = startDate.clone();
    }
});
